// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-btn {
    text-align: right;
    position: absolute;
    top: 9px;
    right: 50px;
}
.close-btn .material-icons {
    padding: 5px;
    border: 1px #ddd solid;
    border-radius: 50px;
    position: absolute;
    background-color: #fff;
}
.modal-header h3 {
    text-align: center;
    color: #003561;
    font-family:Roboto, "Helvetica Neue", sans-serif;
    margin: 0px;
}
.modal-header {
    border-bottom: 1px #eee solid;
    position: relative;
    padding: 15px 0px;
    background-color: #f2f2f2;
}
::ng-deep .mat-dialog-container {
    font-family:Roboto, "Helvetica Neue", sans-serif;
    letter-spacing: 0.5px;
    padding: 0px;
    overflow: auto;
    overflow-x: hidden;
    max-height: 550px;
}
.mat-fab {
    position: sticky;
    bottom: 10px;
    right: 10px;
    float: right;
}
::ng-deep .mat-fab .mat-button-wrapper {
    padding: 10px;
}
::ng-deep .mat-fab {
    border-radius: 5px;
    width: max-content;
    height: auto;
    padding: 0 8px;
    font-family:Roboto, "Helvetica Neue", sans-serif;
    letter-spacing: 1px;
}
.width-75 {
    width: 75%;
}
.layer-name {
    font-style: italic;
    letter-spacing: 1px;
    font-weight: 100;
    margin: 5px;
}
.example-full-width {
    width: 100%;
  }
  `, "",{"version":3,"sources":["webpack://./src/app/app-share-map-module/admin-layer-download/admin-layer-download.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,gDAAgD;IAChD,WAAW;AACf;AACA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,gDAAgD;IAChD,qBAAqB;IACrB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,gDAAgD;IAChD,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,WAAW;EACb","sourcesContent":[".close-btn {\n    text-align: right;\n    position: absolute;\n    top: 9px;\n    right: 50px;\n}\n.close-btn .material-icons {\n    padding: 5px;\n    border: 1px #ddd solid;\n    border-radius: 50px;\n    position: absolute;\n    background-color: #fff;\n}\n.modal-header h3 {\n    text-align: center;\n    color: #003561;\n    font-family:Roboto, \"Helvetica Neue\", sans-serif;\n    margin: 0px;\n}\n.modal-header {\n    border-bottom: 1px #eee solid;\n    position: relative;\n    padding: 15px 0px;\n    background-color: #f2f2f2;\n}\n::ng-deep .mat-dialog-container {\n    font-family:Roboto, \"Helvetica Neue\", sans-serif;\n    letter-spacing: 0.5px;\n    padding: 0px;\n    overflow: auto;\n    overflow-x: hidden;\n    max-height: 550px;\n}\n.mat-fab {\n    position: sticky;\n    bottom: 10px;\n    right: 10px;\n    float: right;\n}\n::ng-deep .mat-fab .mat-button-wrapper {\n    padding: 10px;\n}\n::ng-deep .mat-fab {\n    border-radius: 5px;\n    width: max-content;\n    height: auto;\n    padding: 0 8px;\n    font-family:Roboto, \"Helvetica Neue\", sans-serif;\n    letter-spacing: 1px;\n}\n.width-75 {\n    width: 75%;\n}\n.layer-name {\n    font-style: italic;\n    letter-spacing: 1px;\n    font-weight: 100;\n    margin: 5px;\n}\n.example-full-width {\n    width: 100%;\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
